export const DEFAULT_TABLE_LIMIT = 10;
export const DEFAULT_TABLE_OFFSET = 0;

export const TIME_FORMATS = {
  DATE: 'DD/MM/YYYY',
  DATE_TIME: 'DD/MM/YYYY HH:mm',
  TIMESTAMP: 'X',
} as const;
